import { useAppSelector } from 'careand-redux/store';
import React, { useMemo } from 'react';
import CalendarUtils from 'services/CalendarUtils';
import moment from 'moment-timezone';
import Icon from 'components/Utils/NewIcon';
import { PhysicianImage } from 'components/Common/UserImage';
import PhysicianUtils from 'services/PhysicianUtils';

const SchedulePhysician = ({ appointment, selectedId, onClick, physicians = [] }) => {
  const allShifts = useAppSelector((state) => state.shifts.shifts);

  const { clinic_id, date } = appointment;

  let shifts = useMemo(() => {
    return CalendarUtils.filterShifts(allShifts, moment.unix(date), clinic_id);
  }, [clinic_id, allShifts, date]);

  return (
    <div className="physician-schedule">
      {physicians.map((physician) => {
        let selected = physician.id === selectedId;
        let hasShift = !!shifts.find((shift) => shift.user_id === physician.id);
        return (
          <PhysicianCheckbox
            physician={physician}
            active={hasShift}
            selected={selected}
            onClick={() => onClick(selected ? undefined : physician.id)}
          />
        );
      })}
    </div>
  );
};

export const PhysicianCheckbox = ({ physician, active, selected, onClick }) => {
  return (
    <div
      className={`physician-schedule-detail ${active ? 'active' : 'inactive'}`}
      key={physician.id}
      onClick={onClick}
    >
      <div className="checkbox">
        <Icon
          width="30px"
          fontAwesomeStyle="fad"
          iconStyle={{
            '--fa-primary-color': 'white',
            '--fa-secondary-opacity': selected ? 1.0 : 0.35,
          }}
          className="blue"
          src="check-circle"
        />
      </div>
      <PhysicianImage user={physician} size={86} />
      <span>{PhysicianUtils.getName(physician)}</span>
    </div>
  );
};

export default SchedulePhysician;
